import { useState } from "react";
import DashboardLayout from "../../../shared/DashboardLayout";

const AddEditBorrower = () => {
  const [formData, setFormData] = useState({
    bf_account_number: "1251",
    bf_borrower_name: "",
    bf_relation_type: "",
    bf_father_name: "",
    bf_cnic: "",
    bf_cheque_number: "",
    bf_image_from_file: null,
    bf_contact_number: "03001234567",
    bf_address: "",
    bf_account_open_date: "",
    bf_is_front: "0",
    bf_house_plan: "",
    bf_house_number: "",
    bf_house_location: "",
    bf_description: "",
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
  };

  return (
    <DashboardLayout>
      <h2 className="m-4">New Borrower</h2>
      <form className="row m-4" onSubmit={handleSubmit}>
        <div className="col-lg-4">
          <label htmlFor="bf_account_number" className="form-label fw-bolder">
            File Number
            <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="text"
            className="form-control"
            name="bf_account_number"
            id="bf_account_number"
            value={formData.bf_account_number}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_borrower_name" className="form-label fw-bolder">
            Name
            <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="text"
            className="form-control"
            name="bf_borrower_name"
            id="bf_borrower_name"
            value={formData.bf_borrower_name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_relation_type" className="form-label fw-bolder">
            Relation
            <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <select
            name="bf_relation_type"
            id="bf_relation_type"
            className="form-control"
            value={formData.bf_relation_type}
            onChange={handleChange}
            required
          >
            <option value="" disabled>
              -- Relation --
            </option>
            <option value="son_of">Son of</option>
            <option value="daughter_of">Daughter Of</option>
            <option value="wife_of">Wife of</option>
          </select>
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_father_name" className="form-label fw-bolder">
            Father's Name
            <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="text"
            className="form-control"
            name="bf_father_name"
            id="bf_father_name"
            value={formData.bf_father_name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_cnic" className="form-label fw-bolder">
            CNIC
            <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="text"
            className="form-control"
            name="bf_cnic"
            id="bf_cnic"
            value={formData.bf_cnic}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_cheque_number" className="form-label fw-bolder">
            Cheque Number
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="text"
            className="form-control"
            name="bf_cheque_number"
            id="bf_cheque_number"
            value={formData.bf_cheque_number}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_image_from_file" className="form-label fw-bolder">
            Profile Picture
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="file"
            className="form-control"
            name="bf_image_from_file"
            id="bf_image_from_file"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_contact_number" className="form-label fw-bolder">
            Contact Number
            <span className="required">*</span>
          </label>
          <p className="fst-italic">Example: 03211234567</p>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="text"
            className="form-control"
            name="bf_contact_number"
            id="bf_contact_number"
            value={formData.bf_contact_number}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_address" className="form-label fw-bolder">
            Address
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="text"
            className="form-control"
            name="bf_address"
            id="bf_address"
            value={formData.bf_address}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4">
          <label
            htmlFor="bf_account_open_date"
            className="form-label fw-bolder"
          >
            Booking Date
            <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="date"
            className="form-control"
            name="bf_account_open_date"
            id="bf_account_open_date"
            value={formData.bf_account_open_date}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_is_front" className="form-label fw-bolder">
            Is Front?
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <select
            name="bf_is_front"
            id="bf_is_front"
            className="form-control"
            value={formData.bf_is_front}
            onChange={handleChange}
          >
            <option value="0">Back</option>
            <option value="1">Front</option>
          </select>
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_house_plan" className="form-label fw-bolder">
            House Plan
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <select
            name="bf_house_plan"
            id="bf_house_plan"
            className="form-control"
            value={formData.bf_house_plan}
            onChange={handleChange}
          >
            <option value="" disabled>
              -- Select --
            </option>
            <option value="1">A-1M FIRST</option>
            <option value="2">B-1M FIRST</option>
            <option value="5">B-1.5M</option>
            <option value="6">B-2M</option>
            <option value="7">C-1M FIRST</option>
            <option value="8">C-1.5M</option>
            <option value="9">C-2M</option>
            <option value="10">C-2.5M</option>
            <option value="11">C-3M</option>
            <option value="12">C-4M</option>
          </select>
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_house_number" className="form-label fw-bolder">
            House Number
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="number"
            className="form-control"
            name="bf_house_number"
            id="bf_house_number"
            value={formData.bf_house_number}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_house_location" className="form-label fw-bolder">
            House Location
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <select
            name="bf_house_plan"
            id="bf_house_plan"
            className="form-control"
            value={formData.bf_house_location}
            onChange={handleChange}
          >
            <option value="" disabled>
              -- Select --
            </option>
            <option value="1">A Block</option>
            <option value="1">B Block</option>
            <option value="1">C Block</option>
            <option value="1">D Block</option>
            <option value="1">E Block</option>
          </select>
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_description" className="form-label fw-bolder">
            Description
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <textarea
            className="form-control"
            name="bf_description"
            id="bf_description"
            rows="5"
            value={formData.bf_description}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-12">
          <button type="submit" className="site_btn btn btn-primary">
            Add Borrower
          </button>
        </div>
      </form>
    </DashboardLayout>
  );
};

export default AddEditBorrower;
